import { ContainerTypes, StepParams } from '@/types/containerTypes';
import { Container } from './container';

export class Step extends Container {
  selectedScenarioId: string | undefined;

  constructor(params: StepParams) {
    super(params);
    this.containerType = ContainerTypes.Step;
    this.selectedScenarioId = params.selectedScenarioId;
  }
}
